import type { ChangeEvent, Ref, RefObject } from 'react';
import { IMaskInput } from 'react-imask';

type MaskedInputProps = {
  mask: string;
  name?: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  ref?: Ref<HTMLInputElement>;
};

const MaskedInput = ({ mask, name, onChange, ref, ...other }: MaskedInputProps) => {
  return (
    <IMaskInput
      {...other}
      mask={mask}
      inputRef={ref as RefObject<HTMLInputElement | null>}
      onAccept={(value: string, _mask, e) => {
        // `e` is set only for a real user input event.  IMask also fires onAccept when its `value`
        // prop is pushed in programmatically (mount, RHF `reset()`); forwarding those feeds the value
        // straight back into the controlled prop and loops ("Maximum update depth exceeded").
        if (!e) {
          return;
        }
        onChange?.({ target: { name: name ?? '', value } } as ChangeEvent<HTMLInputElement>);
      }}
      overwrite
    />
  );
};

export default MaskedInput;
